import axiosInstance from "../axios/axiosInstance";

export async function get(url, config = {}) {
    return await axiosInstance
      .get(url, { ...config })
      .then(response => response.data)
      .catch(error => {
        console.log("[API GET Error]", url, error);
        // Handle various error formats
        const errorData = error.response?.data || error.response || error;
        throw errorData;
      });
}

export async function post(url, data, config = {}) {
    return await axiosInstance.post(url, data, config)
    .then((response) => response.data)
    .catch((error) => {
        console.log("[API POST Error]", url, error);
        console.log("[API POST Error] Response:", error.response);
        // Handle various error formats
        const errorData = error.response?.data || error.response || error;
        throw errorData;
    });
}